import { render } from "./PeriodontalReports.vue?vue&type=template&id=4c6dd53b&scoped=true&ts=true"
import script from "./PeriodontalReports.vue?vue&type=script&lang=ts"
export * from "./PeriodontalReports.vue?vue&type=script&lang=ts"

import "./PeriodontalReports.vue?vue&type=style&index=0&id=4c6dd53b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6dd53b"]])

export default __exports__